module.exports = __WEBPACK_EXTERNAL_MODULE_176__;


//////////////////
// WEBPACK FOOTER
// external "@panter/vue-i18next"
// module id = 176
// module chunks = 0